import React, {useState, useEffect} from "react";
import "./Login.scss";
import { FiEye, FiEyeOff } from "react-icons/fi";
import { Link } from "react-router-dom";

import { connect } from "react-redux";
import { checkLogin, loginSetError } from "../../../store/auth/actions";
import Swal from "sweetalert2";

const Login = (props) => {
  const [secureText, setSecureText] = React.useState(true);
  const [state, setState] = useState({
    email: "",
    password: "",
  });
  const handleLogin = async (e) => {
    e.preventDefault();
    try{
    const { email, password } = state;
    const { checkLogin } = props;
    await checkLogin({ email, password });
    props.history.push("/dashboard");
    }catch(err){
      if(err?.response?.data?.password || err?.response?.data?.email){
        Swal.fire("Incorrect email/password", "", "error")
      }
    }
  };
  useEffect(() => {
    // Anything in here is fired on component mount.
    return () => {
      // Anything in here is fired on component unmount.
      props.loginSetError({message:{}})
    };
  }, []);

  return (
    <div className="login">
      <div className="left">
        <img src="/images/bg/login-bg.png" alt="" className="img-fluid" />
      </div>
      <div className="right">
        <form action="" className="form" onSubmit={handleLogin} >
          <div className="h1">Log in</div>
          <div className="input-wrapper">
            <div className="input-top">
              <label htmlFor="" className="input-top-label">
                Email
              </label>
            </div>
            <input
              type="email"
              className="input form-control"
              placeholder="e.g. example@gmail.com"
              onChange={(e) => setState({ ...state, email: e.target.value })}
              value={state.email}
              required
            />
          </div>
          <div className="input-wrapper">
            <div className="input-top justify-content-between">
              <label htmlFor="" className="input-top-label">
                Password
              </label>
              <Link className="linked" to="/forgot-password">
                Forgot Password?
              </Link>
            </div>
            <input
              type={`${secureText === true ? "password" : "text"}`}
              className="input form-control"
              placeholder=""
              onChange={(e) => setState({ ...state, password: e.target.value })}
              value={state.password}
              required
            />
            <div
              className="secure-eye"
              onClick={() => {
                setSecureText(!secureText);
              }}
            >
              {secureText ? <FiEye /> : <FiEyeOff />}
            </div>
          </div>
          {/* <div className="input-wrapper">
            <div className="input-top">
              <input
                class="input-check mr-4"
                type="checkbox"
                value=""
                id="flexCheckDefault"
              />
              <label class="input-top-label" for="flexCheckDefault">
                Keep me sign in
              </label>
            </div>
          </div> */}
          <div className="input-wrapper">
            <input
              type="submit"
              value={props.loading ? "..." : "Log In"}
              className="btn btn-primary rounded-3 btn-block btn-lg mt-4"
              disabled={props.loading}
            />
          </div>
          <div className="mt-3 text-center h5 text-muted w-100 ">
            Don't have an account?{" "}
            <Link className="linked" to="/signup">
              Sign Up
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  loading: state.auth.loading,
  errorMessage: state.auth.errorMessage,
});
export default connect(mapStateToProps, {
  checkLogin,
  loginSetError,
})(Login);
